import { combineReducers } from 'redux';

import {
  getCreditListRequest,
  getCreditListSuccess,
  getCreditListFail,
  setCreditListDirty,
  clearCreditList,
} from '../actions';
import { CreditAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { ItemList } from '../../../../types/main';
import { Credit } from '../../../../types/items';
import { stripItems } from '../../../../utility/store';

type State = Loadable<ItemList<Credit>>;
type ReducerOf<T extends keyof State> = Reducer<State, CreditAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getCreditListRequest.type:
      return state ? stripItems(state) : null;

    case getCreditListSuccess.type:
      return action.payload;

    case clearCreditList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getCreditListRequest.type:
      return true;

    case getCreditListSuccess.type:
    case getCreditListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setCreditListDirty.type:
      return action.payload;

    case getCreditListSuccess.type:
    case getCreditListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  dirty,
});
